import { endpoints } from '@/api/endpoints';
import { MasterCrud } from '@/components/MasterCrud';
import { Input, Textarea } from '@/components/ui/Input';
import { fmtPhone } from '@/utils/format';

interface SupplierRow {
  id: number;
  name: string;
  phone?: string;
  gstin?: string;
  address?: string;
  notes?: string;
}
interface SupplierForm {
  name: string;
  phone: string;
  gstin: string;
  address: string;
  notes: string;
}

export function SuppliersListPage() {
  return (
    <MasterCrud<SupplierRow, SupplierForm>
      title="Suppliers"
      description="Whoever you buy stock from. Keeps purchase history clean."
      listUrl={endpoints.suppliers}
      itemUrl={endpoints.supplier}
      queryKey="suppliers"
      newForm={() => ({ name: '', phone: '', gstin: '', address: '', notes: '' })}
      toForm={(r) => ({
        name: r.name ?? '',
        phone: r.phone ?? '',
        gstin: r.gstin ?? '',
        address: r.address ?? '',
        notes: r.notes ?? '',
      })}
      toBody={(f) => ({
        name: f.name.trim(),
        phone: f.phone.trim() || undefined,
        gstin: f.gstin.trim() || undefined,
        address: f.address.trim() || undefined,
        notes: f.notes.trim() || undefined,
      })}
      columns={[
        { key: 'name', header: 'Name', cell: (r) => r.name },
        {
          key: 'phone',
          header: 'Phone',
          hideOnMobile: true,
          cell: (r) => fmtPhone(r.phone),
        },
        {
          key: 'gstin',
          header: 'GSTIN',
          hideOnMobile: true,
          cell: (r) => (
            <span className="font-mono text-xs">{r.gstin ?? '—'}</span>
          ),
        },
      ]}
      formFields={(value, setValue) => (
        <div className="space-y-3">
          <Input
            name="name"
            label="Name"
            autoFocus
            value={value.name}
            onChange={(e) => setValue({ ...value, name: e.target.value })}
          />
          <Input
            name="phone"
            label="Phone"
            value={value.phone}
            onChange={(e) => setValue({ ...value, phone: e.target.value })}
          />
          <Input
            name="gstin"
            label="GSTIN"
            value={value.gstin}
            onChange={(e) => setValue({ ...value, gstin: e.target.value })}
          />
          <Textarea
            name="address"
            label="Address"
            value={value.address}
            onChange={(e) => setValue({ ...value, address: e.target.value })}
          />
          <Textarea
            name="notes"
            label="Notes"
            rows={2}
            value={value.notes}
            onChange={(e) => setValue({ ...value, notes: e.target.value })}
          />
        </div>
      )}
    />
  );
}
